import TrashCan16 from '@carbon/icons-react/es/trash-can/16';
import React, { FC } from 'react';
import { ColumnHeader } from 'components/atoms/table';
import { TranslationKey, useTranslation } from 'hooks/use-translation';

interface Props {
  name: string;
  deleted?: boolean;
}
export const CategoryHeader: FC<Props> = ({ name, deleted = false }) => (
  <ColumnHeader
    icon={deleted ? <TrashCan16 /> : null}
    title={name}
    description={useTranslation(
      `timesheets.labels.${
        deleted ? 'deleted_category' : 'category'
      }` as TranslationKey,
    )}
  />
);
